import { mount } from "svelte";
import App from "./App.svelte";

const el = document.getElementById("app");
if (!el) throw new Error("no #app element");
mount(App, { target: el });
